import { useEffect } from "react";

/**
 * VSL video player — Vturb SmartPlayer (converteai.net).
 *
 * Renders the custom `<vturb-smartplayer>` element and injects the player's
 * loader script once per mount. The script is idempotent — if the user
 * navigates between VSL pages the second injection is a no-op because the
 * custom element only registers itself once.
 */
export default function VturbPlayer({
  videoId = "6a4e8bbf3c6dffade0651e08",
  accountId = "266ac8d1-c8a5-46ce-a380-8520236571df",
} = {}) {
  useEffect(() => {
    const src = `https://scripts.converteai.net/${accountId}/players/${videoId}/v4/player.js`;
    if (document.querySelector(`script[src="${src}"]`)) return;
    const s = document.createElement("script");
    s.src = src;
    s.async = true;
    document.head.appendChild(s);
  }, [accountId, videoId]);

  return (
    <section
      data-testid="vsl-section"
      aria-label="Video from Binoye Jos, Esq."
      className="relative bg-paper py-14 md:py-20 border-y border-ink/10"
    >
      <div className="max-w-[1080px] mx-auto px-5 md:px-12 lg:px-20">
        <div className="max-w-[860px] mx-auto text-center mb-8 md:mb-10">
          <p className="font-mono text-[10px] md:text-[11px] tracking-[0.28em] uppercase text-gray-600 mb-4">
            A Message From Binoye Jos, Esq.
          </p>
          <h2 className="font-display text-[30px] md:text-[42px] leading-[1.1] tracking-tight text-ink">
            Watch this before you file a{" "}
            <span className="italic text-teal">single</span> document.
          </h2>
        </div>

        <div className="relative mx-auto max-w-[880px]">
          <vturb-smartplayer
            id={`vid-${videoId}`}
            style={{ display: "block", margin: "0 auto", width: "100%" }}
            data-testid="vturb-smartplayer"
          >
            <div
              className="vturb-player-placeholder"
              style={{
                position: "relative",
                width: "100%",
                padding: "56.25% 0 0",
                zIndex: 0,
                backgroundColor: "black",
              }}
            />
          </vturb-smartplayer>
        </div>
      </div>
    </section>
  );
}
